import * as React from 'react';
import { Layout } from './components/Layout';
import { MinimalLayout } from './components/MinimalLayout';
import SignIn from './components/account/SignIn';
import SignInWith2fa from './components/account/SignInWith2fa';
import SignInWith2faRecoveryCode from './components/account/SignInWith2faRecoveryCode';
import SignOut from './components/account/SignOut';
import Register from './components/account/Register';
import RegisterConfirmEmail from './components/account/RegisterConfirmEmail';
import ForgotPassword from './components/account/ForgotPassword';
import ResetPassword from './components/account/ResetPassword';
import ManageProfile from './components/account/manage/ManageProfile';
import Manage2fa from './components/account/manage/Manage2fa';
import ManagePassword from './components/account/manage/ManagePassword';
import ErrorConfirmEmail from './components/account/error/ErrorConfirmEmail';
import Error from './components/account/Error';
import { ApiClient } from './lib/ApiClient';
import { useAuthenticated } from './components/auth/useAuthenticated'
import './App.scss';
import ImpersonateSignIn from './components/impersonate/ImpersonateSignIn';
import ImpersonateSignOut from './components/impersonate/ImpersonateSignOut';
import ErrorBoundary from './ErrorBoundary';
import { getUrl } from './domain';
//@ts-ignore
import { Helmet } from "react-helmet";
import { useMyOrgAppInfo } from './components/orgs/OrgAppSettingsEndpoints';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './components/account/Home';

const apiClient = new ApiClient();

export default function App() {
    const userAuth = useAuthenticated(apiClient);

    const appInfo = useMyOrgAppInfo();
    let myOrgAppTitle = "";
    let myOrgAppDescription = "";

    if (appInfo?.result !== undefined) {
        myOrgAppTitle = appInfo.result.title;
        myOrgAppDescription = appInfo.result.description;
    }

    return (
        <>
            <div className="application">
                <Helmet>
                    <meta charSet="utf-8" />
                    <link rel="icon" href="/favicon.ico" />
                    <meta name="description" content={`${myOrgAppDescription}`} />
                    <title>{`${myOrgAppTitle}`}</title>
                </Helmet>
            </div>
            <main>
                <ErrorBoundary>
                    <ErrorBoundary>
                        <Routes>
                            <Route element={<Layout key="appLayout" isAuthenticating={userAuth.isAuthenticating} />}>
                                <React.Fragment key="account-login">
                                    <Route path="/account/login" element={<SignIn />} />
                                </React.Fragment>
                                <React.Fragment key="account-login2fa">
                                    <Route path="/account/loginWith2fa" element={<SignInWith2fa />} />
                                </React.Fragment>
                                <React.Fragment key="account-login2faWithRecoveryCode">
                                    <Route path="/account/loginWith2faRecoveryCode" element={<SignInWith2faRecoveryCode />} />
                                </React.Fragment>
                                <React.Fragment key="account-logout">
                                    <Route path="/account/logout" element={<SignOut />} />
                                </React.Fragment>
                                <React.Fragment key="account-register">
                                    <Route path="/account/register" element={<Register />} />
                                </React.Fragment>
                                <React.Fragment key="account-register-confirmEmail">
                                    <Route path="/account/register/confirmEmail" element={<RegisterConfirmEmail />} />
                                </React.Fragment>
                                <React.Fragment key="account-forgotPassword">
                                    <Route path="/account/forgotPassword" element={<ForgotPassword />} />
                                </React.Fragment>
                                <React.Fragment key="account-resetPassword">
                                    <Route path="/account/resetPassword" element={<ResetPassword />} />
                                </React.Fragment>
                                <React.Fragment key="account-manage-profile">
                                    <Route path="/account/manage/profile" element={<ManageProfile />} />
                                </React.Fragment>
                                <React.Fragment key="account-manage-2fa">
                                    <Route path="/account/manage/2fa" element={<Manage2fa />} />
                                </React.Fragment>
                                <React.Fragment key="account-manage-password">
                                    <Route path="/account/manage/password" element={<ManagePassword />} />
                                </React.Fragment>
                                <React.Fragment key="account-error-confirmEmail">
                                    <Route path="/account/error/confirmEmail" element={<ErrorConfirmEmail />} />
                                </React.Fragment>
                            </Route>
                            <Route element={<MinimalLayout key="appLayout" isAuthenticating={userAuth.isAuthenticating} />}>
                                <React.Fragment key="home">
                                    <Route path="/account/home" element={<Home />} />
                                </React.Fragment>
                            </Route>
                            <Route element={<Layout key="appLayout" isAuthenticating={userAuth.isAuthenticating} />}>
                                <React.Fragment>
                                    <Route
                                        path="/"
                                        element={
                                            <Navigate
                                                to={userAuth.isAuthenticated ? getUrl("/account/home") : getUrl("/account/login")}
                                            />
                                        }
                                    />
                                </React.Fragment>
                                <React.Fragment key="account-error">
                                    <Route path="/account/error" element={<Error />} />
                                </React.Fragment>
                                <React.Fragment key="impersonate-login">
                                    <Route path="/impersonate/login" element={<ImpersonateSignIn />} />
                                </React.Fragment>
                                <React.Fragment key="impersonate-logout">
                                    <Route path="/impersonate/logout" element={<ImpersonateSignOut />} />
                                </React.Fragment>
                            </Route>
                        </Routes>
                    </ErrorBoundary>
                </ErrorBoundary>
            </main >
        </>
    );
}
